(ns frontend.test.opensearch-cards.view
  (:require
   [reagent.core :as r]
   [ui.view.opensearch-cards.view :as cards]))

(def sample-card-config
  {:header-fields [{:field-path [:name]
                    :flat-path  [:name]}]
   :body-fields   [{:field-title "Ticket size"
                    :field-path  [:ticket-size]
                    :flat-path   [:ticket-size]}
                   {:field-title "Next step"
                    :field-path  [:next-step]
                    :flat-path   [:next-step]}
                   {:field-title "Region"
                    :field-path  [:region]
                    :flat-path   [:region]}]
   :footer-fields [{:field-title "Updated"
                    :field-path  [:updated-on]
                    :flat-path   [:updated-on]
                    :data-type   :data.type/date}]})

(def owner-footer-config
  (assoc sample-card-config
         :footer-fields [{:field-title "Owner"
                          :field-path  [:owner]
                          :flat-path   [:owner]}]))

(def no-footer-config
  (dissoc sample-card-config :footer-fields))

(def many-footer-config
  (assoc sample-card-config
         :footer-fields [{:field-title "Updated"
                          :field-path  [:updated-on]
                          :flat-path   [:updated-on]
                          :data-type   :data.type/date}
                         {:field-title "Owner"
                          :field-path  [:owner]
                          :flat-path   [:owner]}
                         {:field-title "Region"
                          :field-path  [:region]
                          :flat-path   [:region]}]))

(def sample-cards
  [{:id 1
    :name "Neagen"
    :ticket-size "5 000 000 AED"
    :next-step "Finalize SPA"
    :region "Iberia"
    :updated-on 1774051200000
    :owner "Maria Johansson"}
   {:id 2
    :name "Nordwind Holdings"
    :ticket-size "12 400 000 EUR"
    :next-step "Pending diligence sign-off"
    :region "DACH"
    :updated-on 1773964800000
    :owner "Ari Kallio"}
   {:id 3
    :name "Meridian Capital"
    :ticket-size "Blocked"
    :next-step "Resolve sanction screening mismatch"
    :region "Nordics"
    :updated-on 1773878400000
    :owner "Lina Berg"}
   {:id 4
    :name "Continental Freight Technologies and Logistics Europe Holding Company"
    :ticket-size "7 250 000 SEK"
    :next-step "Wait for the answer of the investment committee about the revised term sheet"
    :region "Benelux"
    :updated-on 1773792000000
    :owner "Eva Lindqvist"}])

(def statuses
  [:won :on-track :lost :no-status])

(def sample-actions
  [{:label    "Put on hold"
    :on-click (fn [_] nil)}
   {:label    "Mark as lost"
    :on-click (fn [_] nil)}])

(defonce playground-state*
  (r/atom {:selected?     false
           :collapsed?    false
           :show-labels?  true
           :status-index  0}))

(defn- control-button
  [{:keys [label on-click]}]
  [:button
   {:type     "button"
    :class    "tw2-rounded-full tw2-border tw2-border-slate-300 tw2-bg-white tw2-px-4 tw2-py-2 tw2-text-sm tw2-font-medium tw2-text-slate-700"
    :on-click on-click}
   label])

(defn- playground-controls
  [state*]
  [:div {:class "tw2-flex tw2-flex-wrap tw2-items-center tw2-gap-3"}
   [control-button
    {:label    (if (:selected? @state*)
                 "Unselect main card"
                 "Select main card")
     :on-click (fn [_]
                 (swap! state* update :selected? not))}]
   [control-button
    {:label    (if (:collapsed? @state*)
                 "Expand main card"
                 "Collapse main card")
     :on-click (fn [_]
                 (swap! state* update :collapsed? not))}]
   [control-button
    {:label    (if (:show-labels? @state*)
                 "Hide labels"
                 "Show labels")
     :on-click (fn [_]
                 (swap! state* update :show-labels? not))}]
   [control-button
    {:label    (str "Cycle status: " (name (nth statuses (:status-index @state*))))
     :on-click (fn [_]
                 (swap! state*
                        update
                        :status-index
                        (fn [idx]
                          (mod (inc idx) (count statuses)))))}]])

(defn- sample-card
  [card config opts]
  [cards/render-card (merge {:card               card
                             :card-config        config
                             :width              "320px"
                             :on-click           (fn [_ _] nil)
                             :on-double-click    (fn [_] nil)
                             :on-toggle-collapse (fn [_] nil)}
                            opts)])

(defn- sample-section
  [title & children]
  (into [:div {:class "tw2-space-y-3"}
         [:div {:class "tw2-text-sm tw2-font-medium tw2-text-slate-500"}
          title]]
        children))

(defn- sample-grid
  [state*]
  (let [{:keys [selected? collapsed? show-labels? status-index]} @state*
        [first-card second-card third-card long-card] sample-cards]
    [:div {:class "tw2-grid tw2-grid-cols-1 tw2-gap-6 md:tw2-grid-cols-2 xl:tw2-grid-cols-3"}
     [sample-section "Interactive (menu, select, collapse, labels, status)"
      [sample-card first-card (assoc sample-card-config :show-labels? show-labels?)
       {:status             (nth statuses status-index)
        :selected?          selected?
        :collapsed?         collapsed?
        :actions            sample-actions
        :on-toggle-collapse (fn [_]
                              (swap! state* update :collapsed? not))}]]
     [sample-section "Selected"
      [sample-card second-card sample-card-config {:selected? true}]]
     [sample-section "Collapsed"
      [sample-card third-card sample-card-config {:collapsed? true}]]
     [sample-section "Status: won (the default)"
      [sample-card first-card sample-card-config {:status :won}]]
     [sample-section "Status: on track (on hold)"
      [sample-card second-card sample-card-config {:status :on-track}]]
     [sample-section "Status: lost"
      [sample-card third-card sample-card-config {:status :lost}]]
     [sample-section "Status: no status (no bar)"
      [sample-card first-card sample-card-config {:status :no-status}]]
     [sample-section "Labels hidden"
      [sample-card second-card (assoc sample-card-config :show-labels? false) {}]]
     [sample-section "Compact (two rows)"
      [sample-card third-card sample-card-config {:compact? true}]]
     [sample-section "Footer with a text, with no date"
      [sample-card first-card owner-footer-config {}]]
     [sample-section "Footer with three fields (date, text, text)"
      [sample-card first-card many-footer-config {}]]
     [sample-section "No footer"
      [sample-card second-card no-footer-config {}]]
     [sample-section "Long title and long values, with a menu"
      [sample-card long-card sample-card-config {:actions sample-actions}]]]))

(defn view
  []
  [:div {:class "tw2 tw2-min-h-screen tw2-bg-slate-100 tw2-p-8"}
   [:div {:class "tw2-mx-auto tw2-max-w-[1200px] tw2-space-y-8"}
    [:div {:class "tw2-space-y-2"}
     [:h1 {:class "tw2-text-3xl tw2-font-semibold tw2-tracking-[-0.03em] tw2-text-slate-950"}
      "OpenSearch Card Playground"]
     [:p {:class "tw2-max-w-3xl tw2-text-sm tw2-text-slate-600"}
      "The Kanban card of the UX mockup, with the classes of the ZapKit Card. Each card has an Open item in its menu."]]
    [playground-controls playground-state*]
    [sample-grid playground-state*]]])
